define('views/modules/calendar/calendar/calendar-component/item/item-move-modal',[
    // Libs
    'underscore', 'mustache', 'moment',
    'services/i18n',
    // events
    'services/events/calendar-events',
    // views
    'views/parts/modal/modal',
    'views/parts/form/datepicker',
    // templates
    'text!templates/modules/calendar/calendar/calendar-component/item/item-move-modal.html'

], function(
    // Libs
    _, Mustache, moment,
    // src
    i18n,
    // events
    CalendarEvents,
    // views
    VModal,
    VDatePicker,
    // templates
    TCalendarItemMoveModal
) {

    var VCalendarItemMoveModal = VModal.extend({
        template: TCalendarItemMoveModal,

        regions: {
            date: ".date-picker",
        },

        modal: function() {
            return {
                title: i18n.t("calendar:move"),
                size: "small",
                className: "calendar-item-move-modal",
            };
        },

        initialize: function() {
            this.view = {
                date: new VDatePicker({
                    label: false,
                    inline: true,
                    responsive: true,
                    attribute: 'date',
                    model: this.model,
                    datepicker: {
                        todayHighlight: false
                    }
                }),
            };
        },

        render: function() {
            var html = Mustache.render(this.template, Mustache.getContext());
            this.$el.empty().append(html);
            this.generateZones()
                .assign(this.view.date, this.zone.$date)
                .renderModal();
            return this;
        },

        setModel: function(model) {
            this.model = model;
            return this;
        },

        onConfirm: function() {
            var newDate = this.view.date.getValue();

            if (newDate && newDate !== this.model.get('date')) {
                var attributes = {
                    date: newDate,
                    done: this.model.get('done') === false ? false : !moment(newDate).isAfter(moment())
                };

                var options = { patch: true };

                if (this.model.get('type') === "animated") {
                    options.autofixRelated = true;
                }

                this.model.save(attributes, options);
            }
        }
    });

    return VCalendarItemMoveModal;
});

